import React from "react";
import { CardList } from "@panda0/panda0-ui";
import { BriefcaseBusiness, GraduationCap } from "lucide-react";

// LinkedIn Section Component
const LinkedInSection = ({ linkedInRef, data }) => {
  return (
    <div ref={linkedInRef} className="pb-10 pt-6 border-t" id="linkedin">
      <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3">
          <BriefcaseBusiness className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">LinkedIn Profile</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Experience Section */}
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
          <div className="flex items-center mb-4">
            <BriefcaseBusiness className="h-5 w-5 text-blue-500 mr-2" />
            <h3 className="text-lg font-medium">Experience</h3>
          </div>

          <div className="space-y-6">
            {data.experience.map((item, index) => (
              <div
                key={index}
                className="border-l-2 border-gray-300 pl-4 relative"
              >
                <div className="absolute -left-[5px] top-0 w-2 h-2 rounded-full bg-gray-500"></div>
                <div className="mb-1">
                  <h4 className="font-semibold">{item.companyName}</h4>
                  <p className="text-sm">{item.designation}</p>
                </div>
                <div className="flex justify-between text-xs text-gray-500">
                  <span>{item.year}</span>
                  <span>{item.location}</span>
                </div>
              </div>
            ))}
          </div>
        </CardList.Card>

        {/* Education Section */}
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
          <div className="flex items-center mb-4">
            <GraduationCap className="h-5 w-5 text-blue-500 mr-2" />
            <h3 className="text-lg font-medium">Education</h3>
          </div>

          <div className="space-y-6">
            {data.education.map((item, index) => (
              <div
                key={index}
                className="border-l-2 border-gray-300 pl-4 relative"
              >
                <div className="absolute -left-[5px] top-0 w-2 h-2 rounded-full bg-gray-500"></div>
                <div className="mb-1">
                  <h4 className="font-semibold">{item.title}</h4>
                  <p className="text-sm">{item.education}</p>
                </div>
                <div className="text-xs text-gray-500">
                  <span>{item.year}</span>
                </div>
              </div>
            ))}
          </div>
        </CardList.Card>
      </div>

      {/* Skills Summary */}
      {/* <div className="mt-6">
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
          <h3 className="text-lg font-medium mb-4">Skills & Endorsements</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {[
              "JavaScript",
              "React",
              "Node.js",
              "SQL",
              "System Design",
              "Product Management",
              "UI/UX",
              "Team Leadership",
            ].map((skill, index) => (
              <div
                key={index}
                className="flex items-center bg-gray-50 p-2 rounded-md"
              >
                <span className="w-6 text-center mr-2 text-sm font-bold text-blue-600">
                  {Math.floor(Math.random() * 20) + 1}
                </span>
                <span className="text-sm">{skill}</span>
              </div>
            ))}
          </div>
        </CardList.Card>
      </div> */}
    </div>
  );
};

export default React.memo(LinkedInSection);
